import React from "react";
import { useTranslate, Show, SimpleShowLayout, TextField } from "react-admin";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

import { useClickAway } from "../../helpers/useClickAway";
import OrderLink from "./OrderLink";
import PaymentStatus from "./PaymentStatus";
import BillplzReceiptLink from "./BillplzReceiptLink";
import PaymentPaidAmount from "./PaymentPaidAmount";
import CustomDateField from "../Common/CustomDateField";

const Root = styled("div")(({ theme }) => ({
  paddingTop: 40,
}));

const TitleWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "1em",
}));

const FormWrapper = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("xs")]: {
    width: 400,
  },
  [theme.breakpoints.down("xs")]: {
    width: "100vw",
    marginTop: -30,
  },
}));

export const PaymentShow = (props) => {
  const { onCancel } = props;
  const translate = useTranslate();
  const wrapperRef = React.useRef(null);
  const [clickAway] = useClickAway(wrapperRef);

  React.useEffect(() => {
    if (clickAway) {
      onCancel();
    }
  }, [clickAway, onCancel]);

  return (
    <Root ref={wrapperRef}>
      <TitleWrapper>
        <Typography variant="h6">{translate("Payment show")}</Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </TitleWrapper>
      <Show title={`Show`} {...props}>
        <SimpleShowLayout toolbar={null}>
          <TextField source="name" />
          <TextField source="type" />
          <TextField source="billId" label={`Bill ID`} />
          <PaymentPaidAmount source="paidAmount" />
          <PaymentStatus />
          <OrderLink />
          <BillplzReceiptLink />
          <CustomDateField source="createdAt" showTime />
          <CustomDateField source="updatedAt" showTime />
        </SimpleShowLayout>
      </Show>
    </Root>
  );
};

export default PaymentShow;
